type AvailableDetailType =
  'sales-amount' | 'sales-quantity' | 'market-share' | 'possession-rate' | 'dn-dv' | 'dynamic-client';

export const routes = {
  performance: { path: '/', name: 'performance' },
  detail: (name: AvailableDetailType | ':name' = ':name') => ({
    path: `/detail/${name}`,
    name: name === ':name' ? 'detail' : name
  }),
  businessEquation: { path: '/business-equation', name: 'business-equation' },
  customerSegmentation: { path: '/customer-segmentation', name: 'customer-segmentation' },
  competitor: {
    vision: { path: '/competitor/vision', name: 'competitor-vision' }
  },
  projects: {
    list: { path: '/reports', name: 'projects' },
    details: { path: '/reports/:id', name: 'project-details' }
  },
  admin: {
    home: { path: '/admin', name: 'administration' },
    account: { path: '/admin/account', name: 'accountManagement' },
    usageTracking: { path: '/admin/usage-tracking', name: 'usageTracking' },
    permissionsManagement: { path: '/admin/permissions-management', name: 'permissionsManagement' },
    permissionsManagementOffers: {
      path: '/admin/permissions-management/offers',
      name: 'permissionsManagementOffers'
    },
    permissionsManagementOrganizations: {
      path: '/admin/permissions-management/organizations',
      name: 'permissionsManagementOrganizations'
    },

    /** @deprecated remove this when permissionsManagementOrganizations is fully implemented */
    organizationsManagementList: {
      path: '/admin/organizations-management',
      name: 'organizationsManagementList'
    },
    /** @deprecated remove this when permissionsManagementOrganizations is fully implemented */
    organizationsManagementCreate: {
      path: '/admin/organizations-management/new',
      name: 'organizationsManagementCreate'
    },
    /** @deprecated remove this when permissionsManagementOrganizations is fully implemented */
    organizationManagementUpdate: (organizationId: string | ':organizationId' = ':organizationId') => ({
      path: `/admin/organizations-management/update/${organizationId}`,
      name: 'organizationsManagementUpdate'
    })
  },
  support: {
    path: '/support',
    name: 'support'
  },
  tools: { path: '/tools', name: 'tools' },
  settings: {
    home: { path: '/settings', name: 'settings' },
    edit: { path: '/settings/edit', name: 'settingsEdit' }
  },
  onboarding: { path: '/onboarding', name: 'onboarding' },
  downloadBucketFile: { path: '/download/:bucketName/:filePath', name: 'downloadBucketFile' },
  error: { path: '/error', name: 'error' },
  authError: { path: '/auth-error', name: 'authError' }
};
